import React, { useState } from 'react';
import {func} from 'prop-types';

import { withStyles, makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeviceIcon from '@material-ui/icons/PersonalVideo';
import BsnSetupIcon from '@material-ui/icons/Assignment';
import FirmwareIcon from '@material-ui/icons/DeveloperBoard';

import DeviceList from '../../components/DeviceList';
import BsnSetupList from '../../components/BsnSetupList';
import FirmwareList from '../../components/FirmwareList';

import './MainLayout.css';

const LogOutButton = withStyles(() => ({
  root: {
    color: '#f8f8f8',
    borderColor: '#f8f8f8'
  }
}))(Button);

const drawerWidth = 210;

const useDrawerStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    top: '80px',
    width: drawerWidth,
    backgroundColor: '#f5f5f5'
  },
  drawerContainer: {
    overflow: 'auto',
  }
}));

function getMainList(drawerSelectedItem) {
  if (drawerSelectedItem === 'devices') {
    return <DeviceList />
  }
  if (drawerSelectedItem === 'bsnSetups') {
    return <BsnSetupList />
  }
  if (drawerSelectedItem === 'firmwares') {
    return <FirmwareList />
  }
}

export default function MainLayout({onLogOut}) {
  const [drawerSelectedItem, setDrawerSelectedItem] = useState('devices');

  const drawerClasses = useDrawerStyles();

  return (
    <div className="MainLayout">
      <header className="MainLayout-header">
        <LogOutButton variant="outlined" style={{marginRight: 30}} onClick={onLogOut}>Log out</LogOutButton>
      </header>
      <Drawer
        className={drawerClasses.drawer}
        variant="permanent"
        classes={{
          paper: drawerClasses.drawerPaper
        }}
      >
        <div className={drawerClasses.drawerContainer}>
          <List>
            {[
              {id: 'devices', label: 'Devices'},
              {id: 'bsnSetups', label: 'BSN Setups'},
              {id: 'firmwares', label: 'Firmwares'}
            ].map(({id, label}) => (
              <ListItem
                key={id}
                button
                selected={id === drawerSelectedItem}
                onClick={() => setDrawerSelectedItem(id)}
              >
                <ListItemIcon>
                  {id === 'devices' ? <DeviceIcon /> : null}
                  {id === 'bsnSetups' ? <BsnSetupIcon /> : null}
                  {id === 'firmwares' ? <FirmwareIcon /> : null}
                </ListItemIcon>
                <ListItemText primary={label} />
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>
      <div className="MainLayout-main">
        {getMainList(drawerSelectedItem)}
      </div>
    </div>
  )
}

MainLayout.propTypes = {
  onLogOut: func
}
